import { siteConfig } from "@/config/siteConfig";

// React 19 hoists these tags into <head> automatically.
export default function Seo({
  title,
  description,
  image,
  path = "",
  type = "website",
}) {
  const fullTitle =
    title && title !== siteConfig.brand
      ? `${title} · ${siteConfig.brand}`
      : siteConfig.brand;
  const url = `${siteConfig.domain}${path}`;
  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </>
  );
}
